import { render, staticRenderFns } from "./modal_show_nullified_publication.vue?vue&type=template&id=0042c10e"
import script from "./modal_show_nullified_publication.vue?vue&type=script&lang=js"
export * from "./modal_show_nullified_publication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports